import { RootState } from '../types'

export const getProfiles = (state: RootState) => state.profiles.profiles
